"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var LabelHeader = function LabelHeader(_ref) {
  var invert = _ref.invert,
    children = _ref.children,
    actions = _ref.actions,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center h-10",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-xs text-light uppercase text-left min-w-0"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'text-light hover:text-dark dark-hover:text-white': !invert,
      'force-dark:text-gray-ultra-light hover:text-white': invert
    }),
    style: {
      marginRight: '-0.3ch'
    }
  }, actions));
};
var _default = exports["default"] = LabelHeader;
//# sourceMappingURL=LabelHeader.js.map